import React from 'react';
import PropTypes from 'prop-types';

const Pin = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={18} height={20} fill="none" {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M9 20C7.666 20 .818 13.533.818 8.182S4.482 0 9 0c4.518 0 8.182 2.83 8.182 8.182C17.182 13.532 10.335 20 9 20Zm0-7.273a4.545 4.545 0 1 0 0-9.09 4.545 4.545 0 0 0 0 9.09Z"
      clipRule="evenodd"
    />
  </svg>
);

Pin.propTypes = {
  color: PropTypes.string
};

export default Pin;
